import {
  Button,
  Select,
  Row,
  Spacer,
} from '@oliasoft-open-source/react-ui-library';
import { useFetch } from 'client/hooks/use-fetch';
import { countries } from 'common/countries/countries';
import { getAllArchives } from '../../api-utils';
import { UnpackSteps } from './constants';

type ArchiveSelectorProps = {
  onClose: () => void,
  handleConfirmNextStep: (step: UnpackSteps) => void,
  onPreUnpackObject: Function,
  setSelectedArchive: Function,
  setSelectedCountry: Function
  selectedCountryName: string,
  selectedArchiveId: string,

};

export type TSelectOption = { label: string, value: string };

const prepareArchiveOptions = (archives: any[]): TSelectOption[] => {
  return archives?.map(archive => ({ label: archive.name, value: archive.archiveid }));
};

const prepareCountries = (countries: string[]): TSelectOption[] => {
  return countries?.map(country => ({ label: country, value: country }));
};

export const ArchiveSelector = ({
  onClose,
  handleConfirmNextStep,
  onPreUnpackObject,
  selectedArchiveId,
  setSelectedArchive,
  selectedCountryName,
  setSelectedCountry,
}: ArchiveSelectorProps) => {
  const countrieOptions = prepareCountries(countries);

  const { response: archiveOptions, isLoading } = useFetch<{ value: string }[], []>(getAllArchives, prepareArchiveOptions, []);
  const selectedArchiveOption = archiveOptions?.find(n => n.value === selectedArchiveId);
  const selectedCountrieOptions = countrieOptions.find(n => n.value === selectedCountryName);

  const handlePreUnpack = () => {
    onPreUnpackObject(selectedArchiveId, selectedCountryName);
    handleConfirmNextStep(UnpackSteps.SelectDesing);
  };

  return (
    <div>
      <Row>
        <Select
          onChange={(e: any) => {
            setSelectedArchive(e.target.value);
          }}
          value={selectedArchiveOption}
          options={archiveOptions!}
          placeholder="Select Archive"
        />
      </Row>
      <Spacer />
      <Row>

        <Select
          onChange={(e: any) => {
            setSelectedCountry(e.target.value);
          }}
          value={selectedCountrieOptions}
          options={countrieOptions}
          placeholder="Select default country"
        />

      </Row>
      <Spacer />
      <Row>
        <Button label="Select" onClick={handlePreUnpack} disabled={isLoading || !selectedArchiveOption || !selectedCountrieOptions} colored />
        <Button label="Cancel" onClick={onClose} />
      </Row>
    </div>
  );
};